module.exports = "/images/extra-laptop.svg?5f71e0f2cf5f1c0a5a8e46c4840b6c69";